export const ALERT = "ALERT";
/**
 * returns action for layout fetch init
 */
export const alertMessage = data => {
    return {
        type: ALERT,
        payload: {data}
    }
};